import { styled } from "@mui/material";
import React, { InputHTMLAttributes } from "react";

// Include whether the file selector can accept directory
interface HiddenInputProps extends InputHTMLAttributes<HTMLInputElement> {
  acceptDirectory?: boolean;
}

// Custom component that conditionally adds the webkitdirectory attribute.
const HiddenInputComponent: React.FC<HiddenInputProps> = ({ acceptDirectory, ...props }) => {
  return <input {...props} {...(acceptDirectory ? { webkitdirectory: "true" } : {})} />;
};

// Styling
export const HiddenInput = styled(HiddenInputComponent)(() => ({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
}));
